<template>
  <div>
    <NuxtLink
      :to="localePath({
        name: 'user-user',
        params: {
          user: user.name
        }
      })"
    >
      <ShowcaseCard
        :image="{
          src: props.user.id,
          alt: t('jc.component.userShowcaseCard.avatar.alt', { name: user.name }),
          title: t('jc.component.userShowcaseCard.avatar.title', { name: user.name })
        }"
        provider="xenos"
        :provider-modifiers="{ scale: 16 }"
        :label="props.user.roles ? t('jc.role.' + props.user.roles[0] + '.label') : '-'"
        :text="user.name"
        size="small"
        :class="[ props.user.roles ? 'role-' + UserRoleData[props.user.roles[0]].nameKey : '' ]"
        department
      />
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { UserRoleData } from "~/composables/charon";
import type { User } from "~/composables/charon";

const { t } = useI18n()
const localePath = useLocalePath()

const props = defineProps<{
  user: User
}>()
</script>
